import { Directive, ElementRef, HostListener, Input, Renderer2 } from '@angular/core';
import { ClipboardContent, showCopiedPopup, writeToClipboard } from './clipboard';

@Directive({
  selector: '[copyToClipboard]',
})
export class CopyToClipboardDirective {
  @Input({ required: true }) copyToClipboard: ClipboardContent | null = null;

  constructor(
    private el: ElementRef<HTMLElement>,
    private renderer: Renderer2
  ) {}

  @HostListener('click')
  async copy() {
    if (!this.copyToClipboard) {
      return;
    }
    try {
      await writeToClipboard(this.copyToClipboard);
    } catch (error) {
      console.error(error);
      showCopiedPopup(this.renderer, this.el.nativeElement, 'Kopiëren mislukt');
      return;
    }
    showCopiedPopup(this.renderer, this.el.nativeElement);
  }
}
